/** @format */
import React from 'react';

import getUrlParams from 'utils/getUrlParams';

export const ENV_MODES = {
  DEV: 'DEV',
  QA: 'QA',
  PROD: 'PROD'
};

const getCurrentEnv = () => {
  return ENV_MODES[process.env.REACT_APP_BUILD_ENV] || null;
};

const checkIsQALocalEnv = () => {
  return [ENV_MODES.QA, ENV_MODES.DEV].includes(getCurrentEnv());
};

/**
 * children of this element is visible in QA and DEV env only
 */
// eslint-disable-next-line no-unused-vars
export const QALocalEnvOnly = ({ children }) => {
  if (checkIsQALocalEnv()) {
    // is QA or local dev
    return children;
  } else {
    // is PROD
    return <></>;
  }
};

const utils = {
  getUrlParams,
  getCurrentEnv
};
export default utils;
